import { useState } from "react";
import { CloudinaryImage, CloudinaryVideo } from "../../../Atoms/Cloudinary";
import ModalScreen from "../../../Atoms/ModalScreen";
import styles from "./SumoGallery.module.scss";

interface SumoMedia {
  media: {
    type: string;
    url: string;
  }[];
}

function SumoGallery({ media }: SumoMedia) {
  const [viewingImage, setViewingImage] = useState({
    src: "",
    modalOpen: false,
  });

  return (
    <div className={styles.SumoGalleryWrapper}>
      <div className={styles.SumoGalleryColumn}>
        <div className={styles.MainMediaHolder}>
          {media[0].type === "video" ? (
            <CloudinaryVideo
              src={media[0]}
              muted
              controls
              width={"100%"}
              playsInline
              autoPlay
              loop
              transformations={["h_225"]}
            />
          ) : (
            <div
              onClick={() =>
                setViewingImage({
                  modalOpen: true,
                  src: media[0].url,
                })
              }
            >
              <CloudinaryImage
                src={media[0].url}
                transformations={["h_440", "c_fill"]}
              />
            </div>
          )}
        </div>
      </div>
      <div className={styles.SumoGalleryColumn}>
        {media.slice(1, 4).map((m, index) => {
          return (
            <div
              key={index}
              className={styles.MediaHolder}
              onClick={() =>
                setViewingImage({
                  modalOpen: true,
                  src: m.url,
                })
              }
            >
              <CloudinaryImage
                src={m.url}
                transformations={["h_440", "c_fill"]}
              />
            </div>
          );
        })}
      </div>
      {viewingImage.modalOpen && (
        <ModalScreen
          openVideo={viewingImage.modalOpen}
          onClose={() => {
            setViewingImage({ ...viewingImage, modalOpen: false });
          }}
        >
          <div className={styles.ViewImageModalContainer}>
            <div>
              <CloudinaryImage
                src={viewingImage.src}
                transformations={["w_300", "c_fill"]}
              />
            </div>
          </div>
        </ModalScreen>
      )}
    </div>
  );
}

export default SumoGallery;
